export const initialState = {
  settings: {
    isDesktopApp: null,
  },
  auth: {
    isAuthenticated: null,
    expiresAt: null,
    accessToken: null,
    environment: [],
  },
  context: {
    tags: [],
    subject: null,
    interlocutor: {
      loaded: false,
      id: null,
      edit_url: '',
      app_url: '',
      display_name: '',
      first_name: '',
      last_name: '',
      title: '',
      company: '',
      company_url: '',
      // social networks
      linkedin_url: '',
      twitter_handle: '',
      personal_website: '',
      // stats
      sent_emails_count: null,
      viewed_count: null,
      clicked_count: null,
      replied_count: null,
      call_count: null,
      // contact info
      email_address: null,
      mobile_phone: '',
      contact_phone: '',
      city: '',
      state: '',
      country: '',
      locale: null, // Time Zone
      // company info
      work_city: '',
      work_state: '',
      work_country: '',
      cadence_stage_id: null,
      // not used yet
      company_object_id: null,
      company_proper_domain: '',
      company_proper_name: '',
      created_at: '',
      crm_url: '',
      do_not_contact: '',
      has_replied: '',
      home_phone: '',
      industry: '',
      last_contacted: '',
      phone: '',
      phone_extension: '',
      notes: [],
      tags: [],
      custom_fields: {},
    },
    activities: [],
    cadenceStages: [],
  },
  templates: {
    templatesList: [],
    inProgress: true,
    template: null,
    isOverlayVisible: false,
    isWarningDialogShow: false,
    recipient: null,
    query: '',
    warnings: {
      body: [],
      subject: [],
    },

    templates: [],
    loading: false,
  },
  currentUser: {
    account: {
      permission_names: [],
      crm_token: null,
    },
    features: {},
  },
  crmSyncSettings: {
    gmail_alternate_logging_enabled: false,
  },
  teamEmailSettings: {
    click_tracking_default: undefined,
    open_tracking_default: undefined,
    allow_click_tracking_override: undefined,
    allow_open_tracking_override: undefined,
  },
  teamPrivacySettings: {
    click_tracking_eu_resident: false,
    open_tracking_eu_resident: false,
  },
  fieldOrders: {
    company: {
      field_type: 'company',
      fields_data: {
        fields: [],
      },
      published: false,
    },
    person: {
      field_type: 'person',
      fields_data: {
        fields: [],
      },
      published: false,
    },
  },
  crmReferences: {},
  sentiments: {
    receivedSentiment: {
      id: null,
      sentiment: '',
    },
  },
  calendar: {
    attendees: [],
    isConnected: true,
    calendarSettings: {},
    recurrence: false,
  },
  trackingPreferences: {
    trackOpens: true,
    trackClicks: true,
  },
}

export const settings = (state = initialState.settings, action) => {
  switch (action.type) {
    case 'UPDATE_SETTINGS':
      return Object.assign({}, state, {
        isDesktopApp: action.settings.isDesktopApp,
      })
    default:
      return state
  }
}

export const auth = (state = initialState.auth, action) => {
  switch (action.type) {
    case 'SET_USER_SESSION':
      return Object.assign({}, state, {
        isAuthenticated: action.auth.isAuthenticated,
        expiresAt: action.auth.expiresAt,
        accessToken: action.auth.accessToken,
        environment: action.auth.environment,
      })
    default:
      return state
  }
}

export const context = (state = initialState.context, action) => {
  switch (action.type) {
    case 'SET_INTERLOCUTOR':
      return Object.assign({}, state, {
        interlocutor: action.payload,
      })
    case 'ASSIGN_NOTES':
      return Object.assign({}, state, {
        interlocutor: {
          ...state.interlocutor,
          notes: action.notes,
        },
      })
    case 'SET_ACTIVITIES':
      return Object.assign({}, state, {
        activities: action.activities,
      })
    case 'ADD_ACTIVITY':
      return Object.assign({}, state, {
        activities: [action.activity].concat(state.activities),
      })
    case 'ASSIGN_SUBJECT':
      return Object.assign({}, state, {
        subject: action.subject,
      })
    case 'UPDATE_INTERLOCUTOR_CADENCE_STAGE':
      return {
        ...state,
        interlocutor: {
          ...state.interlocutor,
          cadence_stage_id: action.interlocutor.cadence_stage_id,
        },
      }
    case 'UPDATE_INTERLOCUTOR_DO_NOT_CONTACT':
      return {
        ...state,
        interlocutor: {
          ...state.interlocutor,
          do_not_contact: action.interlocutor.do_not_contact,
        },
      }
    case 'UPDATE_INTERLOCUTOR_DNC_RESTRICTIONS':
      // Build contact_restrictions array based on individual DNC flags
      const updatedPerson = { ...state.interlocutor, ...action.restrictions }
      const contactRestrictions = []

      if (updatedPerson.do_not_call) {
        contactRestrictions.push('call')
      }
      if (updatedPerson.do_not_email) {
        contactRestrictions.push('email')
      }
      if (updatedPerson.do_not_message) {
        contactRestrictions.push('text')
      }

      return {
        ...state,
        interlocutor: {
          ...updatedPerson,
          contact_restrictions: contactRestrictions,
        },
      }
    case 'UPDATE_INTERLOCUTOR_OUT_OF_OFFICE_STATUS':
      return {
        ...state,
        interlocutor: {
          ...state.interlocutor,
          out_of_office: action.interlocutor.out_of_office,
          out_of_office_return_date: action.interlocutor.out_of_office_return_date,
          out_of_office_id: action.interlocutor.out_of_office_id,
        },
      }
    case 'UPDATE_INTERLOCUTOR_ACTIVE_SUCCESS':
      return {
        ...state,
        interlocutor: {
          ...state.interlocutor,
          active_success: action.active_success,
        },
      }
    case 'FETCH_CADENCE_STAGES':
      return Object.assign({}, state, {
        cadenceStages: action.cadenceStages,
      })
    case 'UPDATE_EU_RESIDENT_STATUS':
      return {
        ...state,
        interlocutor: {
          ...state.interlocutor,
          eu_resident: action.interlocutor.eu_resident,
        },
      }
    case 'SET_INTERLOCUTOR_ERROR':
      return Object.assign({}, state, {
        interlocutor: {
          ...state.interlocutor,
          errorStatusCode: action.payload,
        },
      })
    case 'SET_INTERLOCUTOR_LOADED':
      return Object.assign({}, state, {
        interlocutor: {
          ...state.interlocutor,
          loaded: action.payload,
        },
      })
    case 'SET_PERSON_PAUSE_WINDOW':
      return Object.assign({}, state, {
        interlocutor: {
          ...state.interlocutor,
          out_of_office_return_date: action.payload.date,
          out_of_office: true,
          out_of_office_id: action.payload.personPauseWindowId,
        },
      })
    default:
      return state
  }
}

export const templates = (state = initialState.templates, action) => {
  switch (action.type) {
    case 'ASSIGN_TEMPLATES_LIST':
      return Object.assign({}, state, {
        templatesList: action.templatesList,
      })
    case 'ASSIGN_RECIPIENT':
      return Object.assign({}, state, {
        recipient: action.recipient,
      })
    case 'ASSIGN_TEMPLATE_WARNINGS':
      return Object.assign({}, state, {
        warnings: action.warnings,
      })
    case 'TOGGLE_OVERLAY':
      return Object.assign({}, state, {
        isOverlayVisible: action.isOverlayVisible,
      })
    case 'MARK_TEMPLATES_LOADING':
      return Object.assign({}, state, {
        inProgress: action.inProgress,
      })
    case 'SET_TEMPLATE':
      return Object.assign({}, state, {
        template: action.template,
      })
    case 'TOGGLE_DIALOG':
      return Object.assign({}, state, {
        isWarningDialogShow: action.isWarningDialogShow,
      })
    case 'FILTER_TEMPLATES_LIST':
      return {
        ...state,
        query: action.query,
      }
    case 'EXPOSE_TEMPLATES_LIST':
      return Object.assign({}, state, {
        templatesList: state.templatesList.map(template => {
          template.hidden = false
          return template
        }),
      })
    default:
      return state
  }
}

export const currentUser = (state = initialState.currentUser, action) => {
  switch (action.type) {
    case 'ASSIGN_USER':
      return Object.assign({}, state, action.user)
    case 'SET_PERSONAL_SETTINGS':
      return Object.assign({}, state, {
        settings: action.settings,
      })
    default:
      return state
  }
}

export const crmSyncSettings = (state = initialState.crmSyncSettings, action) => {
  switch (action.type) {
    case 'SET_CRM_SYNC_SETTINGS':
      return Object.assign({}, state, action.settings)
    default:
      return state
  }
}

export const teamEmailSettings = (state = initialState.teamEmailSettings, action) => {
  switch (action.type) {
    case 'SET_TEAM_EMAIL_SETTINGS':
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export const teamPrivacySettings = (state = initialState.teamPrivacySettings, action) => {
  switch (action.type) {
    case 'SET_TEAM_PRIVACY_SETTINGS':
      return Object.assign({}, state, action.settings)
    default:
      return state
  }
}

export const requiredFields = (state = initialState.requiredFields, action) => {
  switch (action.type) {
    case 'SET_REQUIRED_FIELDS':
      return Object.assign({}, state, action.requiredFields)
    default:
      return state
  }
}

export const fieldOrders = (state = initialState.fieldOrders, action) => {
  switch (action.type) {
    case 'SET_FIELDS_ORDER':
      return Object.assign({}, state, {
        [action.payload.fieldType]: action.payload.data,
      })
    case 'CLEAR_FIELDS_ORDER':
      return Object.assign({}, state, initialState.fieldOrders)
    default:
      return state
  }
}

export const crmReferences = (state = initialState.crmReferences, action) => {
  switch (action.type) {
    case 'SET_CRM_REFERENCES':
      return Object.assign({}, state, action.references)
    case 'SET_IS_LOADING_CRM_REFERENCES':
      return Object.assign({}, state, {
        isLoadingCrmReferences: action.isLoadingCrmReferences,
      })
    default:
      return state
  }
}

export const sentiments = (state = initialState.sentiments, action) => {
  switch (action.type) {
    case 'SET_RECEIVED_SENTIMENT':
      return Object.assign({}, state, {
        receivedSentiment: action.receivedSentiment,
      })
    default:
      return state
  }
}

export const calendar = (state = initialState.calendar, action) => {
  switch (action.type) {
    case 'SET_ATTENDEES':
      return Object.assign({}, state, {
        attendees: action.attendees,
      })
    case 'SET_CALENDAR_CONNECTED':
      return Object.assign({}, state, {
        isConnected: action.isConnected,
      })
    case 'SET_CALENDAR_SETTINGS':
      return Object.assign({}, state, {
        calendarSettings: action.calendarSettings,
      })
    case 'SET_RECURRENCE':
      return Object.assign({}, state, {
        recurrence: action.hasRecurrence,
      })
    default:
      return state
  }
}

export const trackingPreferences = (state = initialState.trackingPreferences, action) => {
  switch (action.type) {
    case 'SET_TRACKING_PREFERENCES':
      return Object.assign({}, state, action.preferences)
    default:
      return state
  }
}
